<script>
  export default {
    name: 'soccer-entries',
    props: [
      'routeHalfUrl',
      'routeFullUrl',
      'routeResultHalf',
      'routeResultFull',
      'routePaymentHalf',
      'routePaymentFull',
      'routeCancelHalf',
      'routeCancelFull',
      'matchid',
      'hometeamHalfScore',
      'awayteamHalfScore',
      'hometeamFullScore',
      'awayteamFullScore',
      'htState',
      'ftState'
    ],
    data () {
      return {
        isActiveHalf: false,
        isActiveFull: false,
        isActiveCheckHalf: false,
        isActiveCheckFull: false,
        isEditHalf: false,
        isEditFull: false,
        hometeamHalfScoreInner: '',
        awayteamHalfScoreInner: '',
        hometeamFullScoreInner: '',
        awayteamFullScoreInner: '',
        hometeamHalfScoreInnerBeforeEdit: '',
        awayteamHalfScoreInnerBeforeEdit: '',
        hometeamFullScoreInnerBeforeEdit: '',
        awayteamFullScoreInnerBeforeEdit: '',
        fillScoreTextHalf: '',
        fillScoreTextFull: '',
        htStateInner: '',
        ftStateInner: '',
        htProcessingShow: false,
        ftProcessingShow: false,
        processResultHalfShow: false,
        processResultFullShow: false,
        processPaymentHalfShow: false,
        processPaymentFullShow: false,
        SoccerResultChannel: {}
      }
    },
    methods: {
      getApiUrl (path) {
        return this[path].replace('api/', '')
      },
      activeTeamHalf () {
        this.hometeamHalfScoreInnerBeforeEdit = this.hometeamHalfScoreInner
        this.awayteamHalfScoreInnerBeforeEdit = this.awayteamHalfScoreInner
        this.isActiveHalf = true;
      },
      saveScoreHalf () {
        if (this.hometeamHalfScoreInner == '' || this.awayteamHalfScoreInner == '') {
          swal('กรุณาผลให้ครบ', null, 'error')
        } else {
          axios.post(this.getApiUrl('routeHalfUrl'), {
            id: this.matchid,
            score_home_team_ht: this.hometeamHalfScoreInner,
            score_away_team_ht: this.awayteamHalfScoreInner
          })
          .then(response => {
            this.htStateInner = response.data.responseData.ht_state
            this.statusEditChange()
            this.isActiveHalf = false
          })
          .catch(error => {
            // console.log(error)
            // console.log(error.response.data.errors.length)
            if (error.response.data.errors.length > 0) {
              swal('กรุณาผลให้ครบ', null, 'error')
            } else {
              swal('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง', null, 'error')
            }
          });
        }
      },
      cancelScoreHalf () {
        this.hometeamHalfScoreInner = this.hometeamHalfScoreInnerBeforeEdit
        this.awayteamHalfScoreInner = this.awayteamHalfScoreInnerBeforeEdit
        this.isActiveHalf = false;
      },
      activeTeamFull () {
        this.hometeamFullScoreInnerBeforeEdit = this.hometeamFullScoreInner
        this.awayteamFullScoreInnerBeforeEdit = this.awayteamFullScoreInner
        this.isActiveFull = true;
      },
      saveScoreFull () {
        if (this.hometeamFullScoreInner == '' || this.awayteamFullScoreInner == '') {
          swal('กรุณาผลให้ครบ', null, 'error')
        } else {
          axios.post(this.getApiUrl('routeFullUrl'), {
            id: this.matchid,
            score_home_team_ft: this.hometeamFullScoreInner,
            score_away_team_ft: this.awayteamFullScoreInner
          })
          .then(response => {
            this.ftStateInner = response.data.responseData.ft_state
            this.statusEditChange()
            this.isActiveFull = false
          })
          .catch(error => {
            // console.log(error)
            // console.log(error.response.data.errors.length)
            if (error.response.data.errors.length > 0) {
              swal('กรุณาผลให้ครบ', null, 'error');
            } else {
              swal('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง', null, 'error')
            }
          })
        }
      },
      cancelScoreFull () {
        this.hometeamFullScoreInner = this.hometeamFullScoreInnerBeforeEdit
        this.awayteamFullScoreInner = this.awayteamFullScoreInnerBeforeEdit
        this.isActiveFull = false
      },
      statusEditChange () {
        if (this.hometeamHalfScoreInner !='' && this.awayteamHalfScoreInner !='') {
          this.isEditHalf = true
        }

        if (this.hometeamFullScoreInner !='' && this.awayteamFullScoreInner !='') {
          this.isEditFull = true
        }
        this.fillScoreTextHalfFunc()
        this.fillScoreTextFullFunc()
      },
      fillScoreTextHalfFunc () {
        if (this.isEditHalf) {
          this.fillScoreTextHalf = 'แก้ไขผล'
        } else {
          this.fillScoreTextHalf = 'กรอกผล'
        }
      },
      fillScoreTextFullFunc () {
        if (this.isEditFull) {
          this.fillScoreTextFull = 'แก้ไขผล'
        } else {
          this.fillScoreTextFull = 'กรอกผล'
        }
      },
      processResultHalf() {
        axios.post(this.getApiUrl('routeResultHalf'), {
          id: this.matchid
        })
        .then(response => {
          this.htStateInner = response.data.responseData.ht_state
        })
        .catch(error => {
          if (error.response.data.errors.length > 0) {
            swal('กรุณาผลให้ครบ', null, 'error')
          } else {
            swal('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง', null, 'error')
          }
        })
      },
      processPaymentHalf () {
        swal({
          title: "จ่ายเงินแมตซ์ ครึ่งเวลา",
          text: null,
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ตกลง'
        }, () => {
          axios.post(this.getApiUrl('routePaymentHalf'), {
            id: this.matchid
          })
          .then(response => {
            this.htStateInner = response.data.responseData.ht_state
          })
          .catch(error => {
            if (error.response.data.errors.length > 0) {
              swal('กรุณาผลให้ครบ', null, 'error')
            } else {
              swal('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง', null, 'error')
            }
          })
        })
      },
      processPaymentFull () {
        swal({
          title: "จ่ายเงินแมตซ์ เต็มเวลา",
          text: null,
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ตกลง'
        }, () => {
          axios.post(this.getApiUrl('routePaymentFull'), {
            id: this.matchid
          })
          .then(response => {
            this.ftStateInner = response.data.responseData.ft_state
          })
          .catch(error => {
            // console.log(error)
            // console.log(error.response.data.errors.length)
            if (error.response.data.errors.length > 0) {
              swal('กรุณาผลให้ครบ', null, 'error')
            } else {
              swal('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง', null, 'error')
            }
          })
        })
      },
      processResultFull () {
        axios.post(this.getApiUrl('routeResultFull'), {
          id: this.matchid
        })
        .then(response => {
          this.ftStateInner = response.data.responseData.ft_state;
        })
        .catch(error => {
          if (error.response.data.errors.length > 0) {
            swal('กรุณาผลให้ครบ', null, 'error')
          } else {
            swal('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง', null, 'error')
          }
        })
      },
      cancelMatchHalf() {
        swal({
          title: "ยกเลิกแมตซ์ ครึ่งเวลา",
          text: null,
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ตกลง'
        }, () => {
          axios.post(this.getApiUrl('routeCancelHalf'), {
            id: this.matchid
          })
          .then(response => {
            this.htStateInner = response.data.responseData.ht_state
          })
          .catch(error => {
            swal('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง', null, 'error')
          })
        })
      },
      cancelMatchFull () {
        swal({
          title: "ยกเลิกแมตซ์ เต็มเวลา",
          text: null,
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ตกลง'
        }, () => {
          axios.post(this.getApiUrl('routeCancelFull'), {
            id: this.matchid
          })
          .then(response => {
            this.ftStateInner = response.data.responseData.ft_state
          })
          .catch(error => {
            swal('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง', null, 'error')
          })
        })
      }
    },
    mounted () {
      this.SoccerResultChannel = window.pusher.subscribe('soccer-process')
      this.SoccerResultChannel.bind('result-callback-ft-'+this.matchid, (data) => {
        if (data.status == 'success'){
          this.ftStateInner = 'process_result'
        } else {
          swal('เกิดข้อผิดพลาด', null, 'error')
        }
      })

      this.SoccerResultChannel.bind('cancel-callback-ft-'+this.matchid, (data) => {
        if (data.status == 'success') {
          this.ftStateInner = 'process_cancel'
        } else {
          swal('เกิดข้อผิดพลาด', null, 'error')
        }
      })

      this.SoccerResultChannel.bind('payment-callback-ft-'+this.matchid, (data) => {
        if (data.status == 'success') {
          this.ftStateInner = 'process_payment'
        } else {
          swal('เกิดข้อผิดพลาด', null, 'error')
        }
      })

      this.SoccerResultChannel.bind('result-callback-ht-'+this.matchid, (data) => {
        if (data.status == 'success') {
          this.htStateInner = 'process_result'
        } else {
          swal('เกิดข้อผิดพลาด', null, 'error')
        }
      })

      this.SoccerResultChannel.bind('cancel-callback-ht-'+this.matchid, (data) => {
        if (data.status == 'success') {
          this.htStateInner = 'process_cancel'
        } else {
          swal('เกิดข้อผิดพลาด', null, 'error')
        }
      })

      this.SoccerResultChannel.bind('payment-callback-ht-'+this.matchid, (data) => {
        if (data.status == 'success') {
          this.htStateInner = 'process_payment'
        } else {
          swal('เกิดข้อผิดพลาด', null, 'error')
        }
      })

      this.hometeamHalfScoreInner = this.hometeamHalfScore
      this.awayteamHalfScoreInner = this.awayteamHalfScore
      this.hometeamFullScoreInner = this.hometeamFullScore
      this.awayteamFullScoreInner = this.awayteamFullScore
      this.htStateInner = this.htState
      this.ftStateInner = this.ftState
      if (this.htStateInner.indexOf('processing') >= 0) {
        this.htProcessingShow = true
      }
      if (this.ftStateInner.indexOf('processing') >= 0) {
        this.ftProcessingShow = true
      }
      this.statusEditChange()
    },
    watch: {
      isActiveHalf: function (val) {
        this.isActiveCheckHalf = (val && (this.htStateInner == 'none' || this.htStateInner == 'input_result' || this.htStateInner == 'process_result'))
        this.processResultHalfShow = (!val && (this.htStateInner == 'input_result' || this.htStateInner == 'process_result'))
        this.processPaymentHalfShow = (!val && (this.htStateInner == 'process_result'))
      },
      htStateInner: function (val) {
        this.isActiveCheckHalf = (this.isActiveHalf && (val == 'none' || val == 'input_result'))
        this.processResultHalfShow = (!this.isActiveHalf && (val == 'input_result' || val == 'process_result'))
        this.processPaymentHalfShow = (!this.isActiveHalf && (val == 'process_result'))
        this.htProcessingShow = val.indexOf('processing') >= 0
      },
      isActiveFull: function (val) {
        this.isActiveCheckFull = (val && (this.ftStateInner == 'none' || this.ftStateInner == 'input_result' || this.ftStateInner == 'process_result'))
        this.processResultFullShow = (!val && (this.ftStateInner == 'input_result' || this.ftStateInner == 'process_result'))
        this.processPaymentFullShow = (!val && (this.ftStateInner == 'process_result'))
      },
      ftStateInner: function (val) {
        this.isActiveCheckFull = (this.isActiveFull && (val == 'none' || val == 'input_result'))
        this.processResultFullShow = (!this.isActiveFull && (val == 'input_result' || val == 'process_result'))
        this.processPaymentFullShow = (!this.isActiveFull && (val == 'process_result'))
        this.ftProcessingShow = val.indexOf('processing') >= 0
      },

    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/admin/pages/soccer/Entries.vue